var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isEducation)?_c('div',[_c('school-analysis')],1):_c('div',{staticClass:"dashboard-container"},[_c('payment-count'),_c('school-payments',{staticClass:"margin-top"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }